export default {
  client_id: 'namnv8',
  client_secret: '2LXNeWESSaoBTA3pW40uyZB2DqUBjkPk16CvEiyl',
  url: 'https://amduongnguhanh.vn/',
  v1: 'api/v1/',
  v2: 'api/v2/',
  base_url: 'https://amduongnguhanh.vn'
}



// WEBPACK FOOTER //
// ./src/communicate/ApiConfig.js